<template>
	<div>
		<buttonlist
			@help="help"
			@search="search"
			@reflash="reflash"
			@exps="exps"
			ref="SetBtn"
		></buttonlist>
		<el-table
			id="xpane-0"
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
			ref="singleTable"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="po_code" :label="$t('getapi[12852]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[12853]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="delivery_date" :label="$t('getapi[2785]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[1288]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[546]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="client_code" :label="$t('getapi[2610]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="qty" :label="$t('getapi[4517]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="price" :label="$t('getapi[1303]')" align="right"></el-table-column>
			<el-table-column show-overflow-tooltip prop="total" :label="$t('getapi[2102]')" align="right"></el-table-column>
			<!--<el-table-column show-overflow-tooltip prop="invoice_no" :label="$t('getapi[2992]')"></el-table-column>
			<el-table-column show-overflow-tooltip prop="customs_dcl_number" :label="$t('getapi[6986]')"></el-table-column>-->
			<el-table-column show-overflow-tooltip prop="exclusively_id" :label="$t('getapi[3913]')"></el-table-column>
		</el-table>
		<el-row class="page">
			<el-col :span="18">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-sizes="[100, 200, 300, 400]"
					:page-size="pageSize"
					:pager-count="5"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				></el-pagination>
			</el-col>
			<el-col :span="6">
				<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
			</el-col>
		</el-row>
		<serce :isVisible="isVisible" queryData="getonthesea" ref="ser" @getser="serclick"></serce>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'2_getonthesea',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			queryData: [], // 查询数组
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: this.$http.getPageSize('2_getonthesea'), // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = sessionStorage.getItem('userData');
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12850]"),this.$t("getapi[12837]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            if (that.total > 0) {
                that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
            } else {
                that.$refs.SetBtn.SetButtonEnable('search,refresh');
            }
		},
		handleSizeChange(val) {
			this.pageSize = val;
            this.$http.savePageSize('2_getonthesea',val)
			this.getView();
			this.authority();
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getView();
			this.authority();
		},
		// 查询
		search() {
			let that = this;
			that.isVisible = true;
			that.$refs.ser.clearInput(that.isVisible, 'getonthesea');
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.confirmGetView();
		},
		// 确认获取数据
		confirmGetView() {
			let that = this;
            that.pageIndex = 1
			that.isVisible = false;
			that.getView();
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let data = {
				PageIndex: that.pageIndex,
				PageSize: that.pageSize,
				SelectIndex: that.SelectIndexs,
				Param: datac
			};
			that.$http.urlpost('MRP/Tool/GetOnTheSea', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent;
					that.total = res.Totals;
					that.loading = false;
					that.DbTbNames = res.DbTbNames;
					that.authority();
				} else {
					that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		// 导出
		exps() {
			let that = this;
			let datac = [];
			for (let i = 0; i < that.queryData.length; i++) {
				datac.push({
					query_Condition: that.queryData[i].query_Condition,
					query_field_type: that.queryData[i].Query_Field_Type,
					query_field_name: that.queryData[i].Query_Field_Name,
					query_sort: that.queryData[i].query_sort,
					row_sign: that.queryData[i].row_sign
				});
			}
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Ids: '',
				Param: datac
			};
            that.$refs.SetBtn.SetOneBtnEnable('exps',false);
			that.$http.urlpost('/MRP/Tool/GetOnTheSeaToExecl', parm, function(res) {
                that.$refs.SetBtn.SetOneBtnEnable('exps',true);
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				}
			});
		},
        change(e){
            this.type=e;
        },
        getclasslist(classlist)
        {
            // console.log(classlist);
            this.labellist=classlist;
        },
        //popup
        togglePopup(type) {
            this.type = type;
        },
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
</style>
